import { createContext, useContext, useEffect } from 'react'

const FirebaseContext = createContext(null)

export function useFirebase(fn) {
  const firebaseCtx = useContext(FirebaseContext)
  useEffect(() => {
    if (!firebaseCtx) {
      return
    }
    return fn(firebaseCtx)
  }, [firebaseCtx, fn])
}

export default FirebaseContext
